export interface UserMenuItem {
  title: string;
  icon: string;
}

export const userMenuItems: UserMenuItem[] = [
  { title: 'Gestion des comptes', icon: 'fas fa-users-cog' },
];
